module.exports = __webpack_public_path__ + "img/icon_map_3_c.ca806af2.png";